<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper">
        <div class="title-banner-wrapper">
          <h1 class="bani-title mb-0">
            {{ activeLanguageTranslations?.projectOverView }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.projectOverView }}</div>
        <div class="static-content-paragraph">
          <b> {{ activeLanguageTranslations?.sggsProject }} </b> <br />
          {{ activeLanguageTranslations?.subTagLine }}
        </div>

        <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.theVision }}</div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphOne  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphTwo  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphThree  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphFour  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphFive  }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphSix  }}
        </div>

        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.seekingTheLivingGuru  }}</b> <br />
          {{ activeLanguageTranslations?.seekingParagraphOne  }} <br>
          {{ activeLanguageTranslations?.seekingParagraphTwo  }}
        </div>

        <div class="static-content-paragraph">
          <b> {{ activeLanguageTranslations?.focusingGlobalHeading }} </b> <br />
          {{ activeLanguageTranslations?.focusingGlobalParagraphOne }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.focusingGlobalParagraphTwo }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.focusingGlobalParagraphThree }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.focusingGlobalParagraphFour }}
        </div>

        <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.roadMapHeading }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.roadMapParagraphOne }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.roadMapParagraphTwo }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.roadMapParagraphThree }}
        </div>

        <div class="static-content-heading-wrapper"> {{ activeLanguageTranslations?.disclaimerHeading }}</div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.disclaimerParagraphOne }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.disclaimerParagraphTwo }}
        </div>

        <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.aboutHeading }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.aboutParagraphOne }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.aboutParagraphTwo }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.aboutParagraphThree }}
        </div>
        <div class="static-content-paragraph">
          <b>{{ activeLanguageTranslations?.textbooksLabel }}</b> {{ activeLanguageTranslations?.textbooksDetail }}
        </div>
        <div class="static-content-paragraph">
          <b> {{ activeLanguageTranslations?.biBooksHeading }}</b> {{ activeLanguageTranslations?.biBooksDetail }}
        </div>
        <div class="static-content-paragraph">
          <b> {{ activeLanguageTranslations?.lessonPlanHeading }} </b> {{ activeLanguageTranslations?.lessonPlanDetail }}
        </div>
        <div class="static-content-paragraph">
          <b> {{ activeLanguageTranslations?.sikhriOnlineHeading }}  </b> {{ activeLanguageTranslations?.sikhriOnlineParagraphOne }} 
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.sikhriOnlineParagraphTwo }} 
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.sikhriOnlineParagraphThree }} 
        </div>

       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
